var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_vm._ssrNode("<h1"+(_vm._ssrStyle(null,{ 'marginTop':_vm.marginTop+ 'px'}, null))+" data-v-8446d0ce>"+_vm._ssrEscape("\n    "+_vm._s(_vm.title)+"\n  ")+"</h1> <span class=\"decoration\" data-v-8446d0ce></span>")])
}
var staticRenderFns = []

export { render, staticRenderFns }